// extracted by css-extract-rspack-plugin
export default {"title":"title-zwex7u text-4xl-semibold","count":"count-vT3B3u text-xl-medium","description":"description-r6oqNE text-xl-light"};